import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Pagination from '@/components/ui/pagination/Pagination';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import BookCardsList from '@/components/ui/book-cards-list/BookCardsList';
import AdvancedSearchBar from '@/components/ui/advanced-search-bar/AdvancedSearchBar';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';

export interface ILibraryProps {
  books: IBookPage;
}

const AudioBooks: FC<ILibraryProps> = ({ books }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  const currentPage = books.page;

  //Seo block
  const SEO_TITLE = `Слушать Аудиокниги онлайн бесплатно и без регистрации или скачать бесплатно в mp3${currentPage > 1 ? `. Cтраница ${currentPage}.` : ''}`;
  const SEO_DESCRIPTION = `▶ Слушать Аудиокниги онлайн бесплатно и без регистрации или скачать бесплатно в mp3 на cайте Fantasy Worlds.${currentPage > 1 && ` Cтраница ${currentPage}.`}`;
  const SEO_CANONICAL = '/lib/type/audio';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <AdvancedSearchBar />
      <Breadcrumbs firstPageName="Аудиокниги" />
      <Pagination pagesCount={pagesCount ?? 0} postName={`lib/type/audio/`} />
      <SectionTitle name="Аудиокниги" />
      <BookCardsList books={books.data} />
      <Pagination pagesCount={pagesCount ?? 0} postName={`lib/type/audio/`} />
    </Layout>
  );
};

export default AudioBooks;
